import { push, replace } from 'connected-react-router';
import { actionCreators as Notification } from './Notification';
import restHttp from '../../utils/restHttp';

const requestLoginType = 'loyality/user/login/request';
const receiveLoginType = 'loyality/user/login/receive';
export const requestLogoutType = 'loyality/user/logout/request';
const requestListType = 'loyality/user/list/request';
const receiveListType = 'loyality/user/list/receive';
const requestGetType = 'loyality/user/get/request';
const receiveGetType = 'loyality/user/get/receive';
const requestRegisterType = 'loyality/user/register/request';
const receiveRegisterType = 'loyality/user/register/receive';
const requestPasswordType = 'loyality/user/forgot/request';
const receiveForgotType = 'loyality/user/forgot/receive';
const requestPutType = 'loyality/user/put/request';
const receivePutType = 'loyality/user/put/receive';
const switchDisplayStyle = 'loyality/user/display';
const requestDeleteType = 'loyality/user/delete/request';
const receiveDeleteType = 'loyality/user/delete/receive';
const requestCouponGetType = 'loyality/user/coupon/get/request';
const receiveCouponGetType = 'loyality/user/coupon/get/receive';
const resetRegistrationType = 'loyality/user/registration/reset';

const initialState = {
  auth: null,
  list: [],
  paging: { sortBy: 'id', sortDescending: false },
  filters: [],
  preferTable: false,
  registration: false,
  passwordChange: null,
  coupons: [],
};

export const actionCreators = {
  requestLogin: (email, password, type) => (dispatch) => {
    dispatch({ type: requestLoginType });

    restHttp
      .post('connect/token/', `grant_type=password&username=${email}&password=${password}&login_hint=${type || ''}`, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
      .then((response) => {
        dispatch({ type: receiveLoginType, auth: response.data });
        dispatch(replace('/'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestLogout: () => async (dispatch) => {
    dispatch({ type: requestLogoutType });
  },
  requestList: (pageIndex, pageSize, sortBy, sortDescending, filters) => (dispatch) => {
    dispatch({ type: requestListType });

    restHttp
      .get('user', restHttp.pageOptions(pageIndex, pageSize, sortBy, sortDescending, filters))
      .then((response) => {
        dispatch({
          type: receiveListType,
          list: response.data,
          paging: restHttp.pagingHeader(response),
          filters,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestGet: id => (dispatch) => {
    dispatch({ type: requestGetType });

    restHttp
      .get(id ? `user/${id}/profile` : 'user/profile')
      .then((response) => {
        dispatch({
          type: receiveGetType,
          current: response.data,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestPut: (id, entity) => (dispatch) => {
    dispatch({ type: requestPutType });

    restHttp
      .put(id ? `user/${id}/profile` : 'user/profile', entity)
      .then(() => {
        dispatch({
          type: receivePutType,
          current: entity,
        });
        dispatch(Notification.addSuccess('Lietotājs atjaunots!'));
        // dispatch(push('/user'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestRegistration: entity => (dispatch) => {
    dispatch({ type: requestRegisterType });

    restHttp
      .post('user/registration', entity)
      .then(() => {
        dispatch({
          type: receiveRegisterType,
          registration: true,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestRegistrationConfirmation: entity => (dispatch) => {
    restHttp
      .post('user/registration/confirmation', entity)
      .then(() => {
        dispatch(Notification.addSuccess('Reģistrācija veiksmīga. Parole aizsūtīta SMS veidā!'));
        if (entity.googleUserId) {
          dispatch(actionCreators.requestLogin(entity.googleUserId, entity.googleAccessToken, 'google'));
        } else if (entity.facebookUserId) {
          dispatch(actionCreators.requestLogin(entity.facebookUserId, entity.facebookAccessToken, 'facebook'));
        } else {
          dispatch(push('/login'));
        }
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestChangePassword: entity => (dispatch) => {
    dispatch({ type: requestPasswordType });

    restHttp
      .put('user/password/change', entity)
      .then(() => {
        dispatch({
          type: receiveForgotType,
          passwordChange: entity,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestChangePasswordConfirmation: entity => (dispatch) => {
    restHttp
      .put('user/password/change/confirmation', entity)
      .then(() => {
        dispatch(Notification.addSuccess('Paroles maiņa veiksmīga. Parole aizsūtīta SMS veidā!'));
        dispatch(push('/profile'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestForgotPassword: entity => (dispatch) => {
    dispatch({ type: requestPasswordType });

    restHttp
      .put('user/password/forgot', entity)
      .then(() => {
        dispatch({
          type: receiveForgotType,
          passwordChange: entity,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestForgotPasswordConfirmation: entity => (dispatch) => {
    restHttp
      .put('user/password/forgot/confirmation', entity)
      .then(() => {
        dispatch(Notification.addSuccess('Paroles maiņa veiksmīga. Parole aizsūtīta SMS veidā!'));
        dispatch(push('/login'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestDelete: (id, password) => (dispatch) => {
    dispatch({ type: requestDeleteType });

    restHttp
      .delete(id ? `user/${id}/profile` : `user/profile?password=${password}`)
      .then(() => {
        dispatch({
          type: receiveDeleteType,
          id,
        });
        dispatch(Notification.addSuccess('Profils izdzēsts!'));
        if (id) {
          dispatch(push('/user'));
        } else {
          dispatch(actionCreators.requestLogout());
        }
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestEmail: entity => (dispatch) => {
    restHttp
      .post('user/email', entity)
      .then(() => {
        dispatch(Notification.addSuccess('Epasti izsūtīti!'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestPush: entity => (dispatch) => {
    restHttp
      .post('user/push', entity)
      .then(() => {
        dispatch(Notification.addSuccess('Notifikācijas izsūtītas!'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  switchDisplayStyle: () => (dispatch) => {
    dispatch({ type: switchDisplayStyle });
  },
  requestUcsVersion: () => (dispatch) => {
    restHttp
      .get('user/ucs/test')
      .then((response) => {
        dispatch(Notification.addSuccess(`Ucs version: ${response.data.serverInfo}`));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestCouponList: id => (dispatch) => {
    dispatch({ type: requestCouponGetType });

    restHttp
      .get(id ? `user/${id}/coupon` : 'user/coupon')
      .then((response) => {
        dispatch({
          type: receiveCouponGetType,
          coupons: response.data,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  resetRegistration: () => (dispatch) => {
    dispatch({ type: resetRegistrationType });
  },
};

export const reducer = (state, action) => {
  const newState = state || initialState;

  if (
    action.type === requestLoginType
    || action.type === requestLogoutType
    || (action.type === receiveDeleteType && Number(newState.auth.id) === action.id)
  ) {
    return {
      ...newState,
      auth: null,
    };
  }

  if (action.type === receiveRegisterType) {
    return {
      ...newState,
      registration: action.registration,
    };
  }

  if (action.type === receiveForgotType) {
    return {
      ...newState,
      passwordChange: action.passwordChange,
    };
  }

  if (action.type === receiveLoginType) {
    return {
      ...newState,
      auth: action.auth,
    };
  }

  if (action.type === receiveListType) {
    return {
      ...newState,
      list: action.list,
      paging: action.paging,
      filters: action.filters,
    };
  }

  if (action.type === requestCouponGetType) {
    return {
      ...newState,
      coupons: [],
    };
  }

  if (action.type === receiveCouponGetType) {
    return {
      ...newState,
      coupons: action.coupons,
    };
  }

  if (action.type === requestGetType) {
    return {
      ...newState,
      current: null,
    };
  }

  if (action.type === receiveGetType || action.type === receivePutType) {
    return {
      ...newState,
      current: action.current,
      auth:
        action.current.id === Number(newState.auth.id) && action.type === receivePutType
          ? {
            ...newState.auth,
            name: action.current.name,
            email: action.current.email,
            phone: action.current.phone,
          }
          : newState.auth,
    };
  }

  if (action.type === switchDisplayStyle) {
    return {
      ...newState,
      preferTable: !state.preferTable,
    };
  }

  if (action.type === resetRegistrationType) {
    return {
      ...newState,
      registration: false,
    };
  }

  return newState;
};

export const selectors = {
  getIsAdmin: state => state.user.auth && state.user.auth.isAdmin === 'True',
  getIsAuthenticated: state => state.user.auth !== null,
};



// WEBPACK FOOTER //
// ./src/store/modules/User.js